export default function NotFound() {
  return (
    <div className="not-found">
      <span className="not-found-prompt">🦖 404 Not Found :(</span>
    </div>
  );
}
